import * as React from 'react';
import classnames from 'classnames';
import { LimeWrapper } from '@grandvisionhq/lib-lime';
import { useSelector } from '@grandvisionhq/state';
import { useTransitionColor } from '../../../hooks/use-transition-color.js';
import { useRxConfiguratorSlots } from '../../../slots/context.js';
import '../../../state/actions.js';
import '../../../state/add-to-cart/selectors.js';
import '../../../state/bundles/selectors.js';
import '../../../state/bundles/reducer.js';
import { getSelectedFrame, getSelectedAddOn, getFrameImage } from '../../../state/configurator/selectors.js';
import '../../../state/configurator/reducer.js';
import '../../../state/products/selectors.js';
import '../../../state/products/reducer.js';
import '@grandvisionhq/lib-lime/css';

const FrameImage = ({ className  })=>{
    var ref;
    const transitionColor = useTransitionColor();
    const { Slots  } = useRxConfiguratorSlots();
    const frame = useSelector(getSelectedFrame);
    const selectedAddOn = useSelector(getSelectedAddOn);
    const frameImage = useSelector((s)=>getFrameImage(s, {
            width: 592
        })
    );
    const altText = `${frame === null || frame === void 0 ? void 0 : frame.brand} ${frame === null || frame === void 0 ? void 0 : frame.code}`;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('frame-image', className)
    }, frame && frameImage && Slots.ProductImage ? /*#__PURE__*/ React.createElement(Slots.ProductImage, {
        className: "frame-image__product",
        imageUrl: frameImage.url,
        altText: altText
    }, transitionColor && /*#__PURE__*/ React.createElement(LimeWrapper, {
        frameUPC: frame.sku,
        frameSrc: frameImage.url,
        lensColor: transitionColor,
        transitionType: selectedAddOn === null || selectedAddOn === void 0 ? void 0 : (ref = selectedAddOn.transitionType) === null || ref === void 0 ? void 0 : ref.toLowerCase()
    })) : null);
};

export { FrameImage };
//# sourceMappingURL=FrameImage.js.map
